// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.container {
  width: 100%;
  max-width: 1170px;
  margin: auto;
  padding: 0 15px;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.footer-col {
  flex: 1 1 30%;
  padding: 15px;
}

.footer-section {
  background: #131921;
  color: #ffffff;
  padding-top: 50px;
}

.footer-cta {
  border-bottom: 1px solid #373636;
  margin-bottom: 50px;
}

.single-cta i {
  color: #e6002a;
  font-size: 30px;
  float: left;
  margin-top: 8px;
  margin-right: 15px;
}

.cta-text h4 {
  color: white;
  font-size: 20px;
  font-weight: 600;
}

.cta-text span {
  color: #757575;
  font-size: 15px;
}

.footer-widget {
  margin-bottom: 30px;
}

.footer-widget .footer-logo img {
  max-width: 200px;
}

.footer-widget h3 {
  color: #000;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  position: relative;
}

.footer-widget h3::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -10px;
  height: 2px;
  width: 50px;
  background: #e6002a;
}

.footer-widget ul {
  list-style: none;
}

.footer-widget ul li {
  margin-bottom: 10px;
}

.footer-widget ul li a {
  color: #878787;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-widget ul li a:hover {
  color: #e6002a;
}

.footer-social-icon span {
  display: block;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 15px;
}

.footer-text {
  color: white;
}

.footer-social-icon a {
  color: #000;
  font-size: 16px;
  margin-right: 15px;
}

.footer-social-icon i {
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 50%;
}

.footer-widget-heading > * {
  color: white !important;
}

.facebook-bg {
  background: #3b5998;
}

.twitter-bg {
  background: #55acee;
}

.google-bg {
  background: #dd4b39;
}

.subscribe-form input {
  width: calc(100% - 100px);
  padding: 10px;
  margin-top: 8px;

  /* border: 1px solid #2E2E2E; */
  /* color: #000; */
}

.subscribe-form button {
  /* width: 100px; */
  margin-left: 8px;
  font-size: 20px;
  /* background: #e6002a; */
  /* border: 1px solid #e6002a; */
  color: #e6002a;
  cursor: pointer;
}

.copyright-area {
  background: #202020;
}

.copyright-text {
  color: #878787;
  font-size: 12px;
}

.copyright-text a {
  color: #e6002a;
  text-decoration: none;
}

.col-half {
  flex: 1 1 50%;
  padding: 15px;
}

.text-right {
  text-align: right;
}

.footer-menu ul {
  list-style: none;
  text-align: right;
}

.footer-menu ul li {
  display: inline-block;
  margin-left: 20px;
}

.footer-menu ul li a {
  color: #878787;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-menu ul li a:hover {
  color: #e6002a;
}
`, "",{"version":3,"sources":["webpack://./src/style/Footer.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;;EAEf,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.container {\n  width: 100%;\n  max-width: 1170px;\n  margin: auto;\n  padding: 0 15px;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.footer-col {\n  flex: 1 1 30%;\n  padding: 15px;\n}\n\n.footer-section {\n  background: #131921;\n  color: #ffffff;\n  padding-top: 50px;\n}\n\n.footer-cta {\n  border-bottom: 1px solid #373636;\n  margin-bottom: 50px;\n}\n\n.single-cta i {\n  color: #e6002a;\n  font-size: 30px;\n  float: left;\n  margin-top: 8px;\n  margin-right: 15px;\n}\n\n.cta-text h4 {\n  color: white;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.cta-text span {\n  color: #757575;\n  font-size: 15px;\n}\n\n.footer-widget {\n  margin-bottom: 30px;\n}\n\n.footer-widget .footer-logo img {\n  max-width: 200px;\n}\n\n.footer-widget h3 {\n  color: #000;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.footer-widget h3::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -10px;\n  height: 2px;\n  width: 50px;\n  background: #e6002a;\n}\n\n.footer-widget ul {\n  list-style: none;\n}\n\n.footer-widget ul li {\n  margin-bottom: 10px;\n}\n\n.footer-widget ul li a {\n  color: #878787;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-widget ul li a:hover {\n  color: #e6002a;\n}\n\n.footer-social-icon span {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n\n.footer-text {\n  color: white;\n}\n\n.footer-social-icon a {\n  color: #000;\n  font-size: 16px;\n  margin-right: 15px;\n}\n\n.footer-social-icon i {\n  height: 40px;\n  width: 40px;\n  text-align: center;\n  line-height: 40px;\n  border-radius: 50%;\n}\n\n.footer-widget-heading > * {\n  color: white !important;\n}\n\n.facebook-bg {\n  background: #3b5998;\n}\n\n.twitter-bg {\n  background: #55acee;\n}\n\n.google-bg {\n  background: #dd4b39;\n}\n\n.subscribe-form input {\n  width: calc(100% - 100px);\n  padding: 10px;\n  margin-top: 8px;\n\n  /* border: 1px solid #2E2E2E; */\n  /* color: #000; */\n}\n\n.subscribe-form button {\n  /* width: 100px; */\n  margin-left: 8px;\n  font-size: 20px;\n  /* background: #e6002a; */\n  /* border: 1px solid #e6002a; */\n  color: #e6002a;\n  cursor: pointer;\n}\n\n.copyright-area {\n  background: #202020;\n}\n\n.copyright-text {\n  color: #878787;\n  font-size: 12px;\n}\n\n.copyright-text a {\n  color: #e6002a;\n  text-decoration: none;\n}\n\n.col-half {\n  flex: 1 1 50%;\n  padding: 15px;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.footer-menu ul {\n  list-style: none;\n  text-align: right;\n}\n\n.footer-menu ul li {\n  display: inline-block;\n  margin-left: 20px;\n}\n\n.footer-menu ul li a {\n  color: #878787;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-menu ul li a:hover {\n  color: #e6002a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
